<template>
  <div id="app" :class="{ 'h-full': !isIDP, [`ui-mode-${uiMode}`]: true }">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.lang.title,
      meta: [{ vmid: 'description', name: 'description', content: this.lang.description }],
    };
  },
  created() {
    if (new URLSearchParams(window.location.search).has('polling_return')) {
      this.initForPollingReturn();
      return;
    }
    this.loadRecaptcha();
    this.getIsoCountryCode();
    this.getSession();
  },
  mounted() {
    document.addEventListener('DOMContentLoaded', () => {
      const html = document.documentElement;

      if ('IntersectionObserver' in window) {
        const lazyBackgroundObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('lazy-background');
              lazyBackgroundObserver.unobserve(entry.target);
            }
          });
        });

        lazyBackgroundObserver.observe(html);
      } else {
        html.classList.add('lazy-background');
      }
    });
  },
  destroyed() {
    this.$cookies.remove('visitor');
  },
  computed: {
    ...mapState(['lang', 'clientId']),
    ...mapState('auth', ['uiMode']),
    isIDP() {
      return this.clientId?.includes('IDP');
    },
  },
  methods: {
    ...mapActions('auth', [
      'loadRecaptcha',
      'getIsoCountryCode',
      'getSession'
    ]),
    async initForPollingReturn() {
      await this.$store.dispatch('initialLanguage', { mod: 'auth' });
      this.$store.commit('setIsInit', true);
    },
  },
};
</script>
